const env = import.meta.env;

const appConfig = {
  apiStaging: env.VITE_APP_API, //"https://devapi.autogon.ai/api/v1",
  apiPrefix: env.VITE_APP_API, //"https://api.autogon.ai/api/v1",
  apiHostStaging: "https://devapi.autogon.ai/",
  apiHostPrefix: "https://api.autogon.ai/",
  websiteStagingLink :"https://d3nez87f1dbwih.cloudfront.net/",
  websiteProductionLink :"https://autogon.ai/",
  host: "https://console.autogon.ai",
  devHost: "http://localhost:3000",
  stagingHost: "https://devapi.autogon.ai",
  authenticatedFirstEntryPath: "/get-started",
  authenticatedEntryPath: "/dashboard",
  verificationEntryPath: "/verify",
  unAuthenticatedEntryPath: "/sign-in",
  tourPath: "",
  enableMock: false,
};

export default appConfig;
